import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { conditionsGetApi, ConditionsGetApiResponse, SearchConditions } from '../../../external/ConditionsApi';
import { actions } from '../../modules/Actions';
import { filterConditionState } from '../CurrentFilterReducer';
import { SearchConditionItem } from '../SearchConditionReducer';

export const initialFilterListState: filterConditionState[] = [];

export const FilterListReducer = reducerWithInitialState(initialFilterListState).case(
  actions.filterList.update,
  (state: filterConditionState[], payload: filterConditionState[]) => {
    return payload;
  }
);

export async function getFilterList(userId: string): Promise<filterConditionState[]> {
  const response: ConditionsGetApiResponse = await conditionsGetApi({ userId });
  const searchConditions = response.searchConditions;

  return convertResponseToFilterConditionStateList(searchConditions);
}

function convertResponseToFilterConditionStateList(input: SearchConditions[] | undefined): filterConditionState[] {
  const output: filterConditionState[] = [];
  input?.forEach((condition) => {
    const searchConditions: SearchConditionItem[] = [];

    condition.searchBranch.forEach((branch) => {
      searchConditions.push({
        searchConditionGroupId: branch.branchGroupId,
        searchConditionName: branch.branchConditionName,
        specifiedCondition: branch.specifiedCondition,
      });
    });

    output.push({
      filterKey: condition.searchConditionId,
      filterTitle: condition.searchConditionName,
      searchConditions: searchConditions,
    });
  });

  return output;
}
